import { Link } from "react-router-dom";

export default function CallToAction() {
  return (
    <section className="relative py-24 md:py-40 px-5 md:px-10 bg-[var(--ink)] overflow-hidden">
      {/* Background image, dimmed */}
      <div className="absolute inset-0 opacity-30">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FAdwait-project2.0%2FIMG-20231229-WA0100.webp?alt=media&token=f26ada64-160f-4728-91f9-f99c3565e360"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      {/* Gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-[var(--ink)] via-[var(--ink)]/70 to-[var(--ink)]/40" />

      <div className="relative max-w-6xl mx-auto grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-7">
          <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--clay)] mb-6">
            — Have a wall?
          </div>
          <h2 className="font-display font-light text-[clamp(2.5rem,6vw,5.5rem)] leading-[0.95] tracking-tight text-[var(--bone)]">
            Tell us about the <span className="italic font-extralight">wall</span> you'd like us to <span className="text-[var(--clay)]">paint</span>.
          </h2>
          <p className="mt-8 text-[var(--bone)]/80 text-lg max-w-xl">
            We take on a small number of mural commissions every year. Cafés,
            schools, homes, public spaces — across Delhi and beyond.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Link
              to="/booknow"
              className="group inline-flex items-center gap-3 px-7 py-4 bg-[var(--clay)] text-[var(--bone)] rounded-full text-base tracking-wide hover:bg-[var(--bone)] hover:text-[var(--ink)] transition-colors"
            >
              Start a mural
              <span className="relative w-4 h-4 overflow-hidden">
                <span className="absolute inset-0 transition-transform duration-500 group-hover:translate-x-5 group-hover:-translate-y-5">→</span>
                <span className="absolute inset-0 -translate-x-5 translate-y-5 transition-transform duration-500 group-hover:translate-x-0 group-hover:translate-y-0">→</span>
              </span>
            </Link>
            <a
              href="https://wa.me/919911499221"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-7 py-4 border border-[var(--line-strong)] text-[var(--bone)] rounded-full text-base tracking-wide hover:border-[var(--bone)] transition-colors"
            >
              Chat on WhatsApp
            </a>
          </div>
        </div>

        {/* Side stats */}
        <div className="col-span-12 md:col-span-5 md:pl-12 md:border-l md:border-[var(--line)]">
          <div className="space-y-8 pt-2">
            {[
              { k: "Currently booking", v: "Aug 2026 onward" },
              { k: "Studio territory", v: "Delhi NCR + travel" },
              { k: "Response time", v: "Within 24 hours" },
            ].map((row) => (
              <div key={row.k} className="border-b border-[var(--line)] pb-6">
                <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--muted)]">
                  {row.k}
                </div>
                <div className="mt-2 font-display text-2xl md:text-3xl text-[var(--bone)]">
                  {row.v}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}